function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { productLstApi, productDeleteApi, putOnShellApi, offShellApi, productHeadersApi, restoreApi, productExcelApi, productAuditApi, productBatchDownApi, productBatchUpApi, productSetFreightApi, productBatchFreightApi, productBrokerageApi, productBatchBrokerageApi, productBatchAddCouponsApi, productAddCouponsApi, productBatchDeleteApi, productBatchRecycleApi, productBatchRestoreApi, productBatchAuditApi } from '@/api/product';
import { getToken } from '@/utils/auth';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import { mapGetters } from 'vuex';
import storeEdit from './components/storeEdit';
import productTpye from './components/productTpye.vue';
import { ProductTypeEnum as _ProductTypeEnum } from '@/enums/productEnums';
import * as $constants from '@/utils/constants';
import { useProduct } from '@/hooks/use-product';
import { handleDeleteTable } from '@/libs/public';
var _useProduct = useProduct(),
  productTypeList = _useProduct.productTypeList;
var objTitle = ['出售中', '仓库中', '已售罄', '警戒库存', '回收站', '待审核', '审核失败', '待提审'];
var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  cateId: '',
  keywords: '',
  type: '1',
  categoryId: null,
  isPaidMember: null,
  productType: null
};
export default {
  name: 'ProductList',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop < this.clientHeight + 1) {
            binding.value();
          }
        });
      }
    }
  },
  components: {
    storeEdit: storeEdit,
    productTpye: productTpye
  },
  data: function data() {
    var _this2 = this;
    var validateCommissionRatio = function validateCommissionRatio(rule, value, callback) {
      if (_this2.commisionForm.commissionType !== 1) return callback();
      if (value === '' || value === undefined || value === null) return callback(new Error('请输入佣金比例'));
      if (Number(value) < 0 || Number(value) > 100) return callback(new Error('佣金比例范围为 0~100'));
      callback();
    };
    var validateCommissionAmount = function validateCommissionAmount(rule, value, callback) {
      if (_this2.commisionForm.commissionType !== 2) return callback();
      if (value === '' || value === undefined || value === null) return callback(new Error('请输入固定佣金'));
      if (Number(value) < 0) return callback(new Error('固定佣金不能小于 0'));
      callback();
    };
    return {
      productTypeList: productTypeList,
      //商品类型
      drawer: false,
      direction: 'rtl',
      propsPlant: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      propsMer: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false,
        checkStrictly: true
      },
      headeNum: [],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: Object.assign({}, tableFroms),
      keywords: '',
      categoryList: [],
      objectUrl: process.env.VUE_APP_BASE_API,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['ID', '商品图', '商品名称', '商品售价', '销量', '库存', '状态'],
      columnData: ['ID', '商品图', '商品名称', '商品售价', '销量', '库存', '状态'],
      isIndeterminate: true,
      productId: 0,
      stockEdit: false,
      multipleSelectionAll: [],
      checkedIds: [],
      //选中的id
      ruleValidate: {
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }]
      },
      formValidate: {
        tempId: ''
      },
      loadingBtn: false,
      dialogVisible: false,
      dialogCommision: false,
      //佣金弹窗
      commisionForm: {
        commissionType: 1,
        brokerage: 0,
        brokerageTwo: 0,
        firstAmount: 0,
        secondAmount: 0,
        id: 0,
        idList: []
      },
      //设置佣金表单
      commisionRule: {
        commissionType: [{
          required: true,
          message: '请选择佣金模式',
          trigger: 'change'
        }],
        brokerage: [{
          validator: validateCommissionRatio,
          trigger: 'change'
        }],
        brokerageTwo: [{
          validator: validateCommissionRatio,
          trigger: 'change'
        }],
        firstAmount: [{
          validator: validateCommissionAmount,
          trigger: 'change'
        }],
        secondAmount: [{
          validator: validateCommissionAmount,
          trigger: 'change'
        }]
      },
      keyNum: 0,
      couponIds: [],
      //优惠券集合
      productInfo: null,
      //商品详情
      productType: 0,
      //商品类型
      isSub: false,
      //佣金设置是否单独设置
      addType: 'isAdd'
    };
  },
  computed: _objectSpread({
    ProductTypeEnum: function ProductTypeEnum() {
      return _ProductTypeEnum;
    },
    //操作上下架禁用
    IsShow: function IsShow() {
      return this.tableFrom.type == _ProductTypeEnum.RecycleBin || this.tableFrom.type == _ProductTypeEnum.Audit || this.tableFrom.type == _ProductTypeEnum.ReviewFailed || this.tableFrom.type == _ProductTypeEnum.PendingReview;
    },
    //已售罄或者警戒库存
    SoldOutAndAlertInventory: function SoldOutAndAlertInventory() {
      return this.tableFrom.type == this.ProductTypeEnum.SoldOut || this.tableFrom.type == this.ProductTypeEnum.AlertInventory;
    },
    //已售罄、警戒库存操作判断
    operation: function operation() {
      return this.tableFrom.type == this.ProductTypeEnum.SoldOut || this.tableFrom.type == this.ProductTypeEnum.AlertInventory;
    },
    //加入回收站 操作
    RecycleBin: function RecycleBin() {
      return this.tableFrom.type == this.ProductTypeEnum.Audit || this.tableFrom.type == this.ProductTypeEnum.ReviewFailed || this.tableFrom.type === _ProductTypeEnum.InTheWarehouse || this.tableFrom.type === _ProductTypeEnum.PendingReview;
    }
  }, mapGetters(['merPlatProductClassify', 'merProductClassify', 'productBrand', 'shippingTemplates'])),
  activated: function activated() {
    this.goodHeade();
    this.getList(1);
  },
  mounted: function mounted() {
    if (checkPermi(['merchant:product:tabs:headers'])) this.goodHeade();
    if (checkPermi(['merchant:product:page:list'])) this.getList();
    if (!localStorage.getItem('shippingTemplates')) this.$store.dispatch('product/getShippingTemplates');
    this.checkedCities = this.$cache.local.has('goods_stroge') ? this.$cache.local.getJSON('goods_stroge') : this.checkedCities;
    //this.$store.dispatch('product/getAdminProductClassify');
    this.$store.dispatch('product/getAdminProductClassify');
    if (!localStorage.getItem('merProductClassify')) this.$store.dispatch('product/getMerProductClassify');
    this.$store.dispatch('product/getMerProductBrand');
  },
  methods: {
    checkPermi: checkPermi,
    resetCommissionForm: function resetCommissionForm() {
      var _this3 = this;
      this.commisionForm = {
        commissionType: 1,
        brokerage: 0,
        brokerageTwo: 0,
        firstAmount: 0,
        secondAmount: 0,
        id: 0,
        idList: []
      };
      this.$nextTick(function () {
        if (_this3.$refs.commisionForm) {
          _this3.$refs.commisionForm.clearValidate();
        }
      });
    },
    handleCloseCommission: function handleCloseCommission() {
      this.dialogCommision = false;
      this.productInfo = null;
      this.resetCommissionForm();
    },
    //提交审核
    handlePendingReview: function handlePendingReview(row) {
      var _this4 = this;
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个商品');
      if (!row) {
        this.$modalSure("\u786E\u5B9A\u8981\u5C06\u6B64\u5546\u54C1\u63D0\u4EA4\u5E73\u53F0\u5BA1\u6838\u5417\uFF1F").then(function () {
          productBatchAuditApi({
            idList: _this4.checkedIds
          }).then(function () {
            _this4.$message.success('批量提交审核成功');
            _this4.getList('');
            _this4.goodHeade();
          });
        });
      } else {
        this.$confirm('提审之后是否自动上架？', '提示', {
          confirmButtonText: '上架',
          cancelButtonText: '不用了',
          type: 'warning',
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          customClass: 'deleteConfirm'
        }).then(function () {
          _this4.productAudit({
            id: row.id,
            isAutoUp: true
          });
        }).catch(function (action) {
          if (action === 'cancel') {
            _this4.productAudit({
              id: row.id,
              isAutoUp: false
            });
            // 调用取消按钮的方法
          } else if (action === 'close') {
            console.log('Closed');
            // 调用关闭按钮的方法
          }
        });
      }
    },
    //提审提交
    productAudit: function productAudit(data) {
      var _this5 = this;
      productAuditApi(data).then(function (res) {
        _this5.goodHeade();
        _this5.getList();
      });
    },
    //批量加入回收站
    handleRecycleBin: function handleRecycleBin(type) {
      var _this6 = this;
      if (this.checkedIds.length === 0) return this.$message.warning('请至少选择一个商品');
      this.$modalSure(type == 5 ? "\u786E\u5B9A\u6279\u91CF\u5220\u9664\u5546\u54C1\u5417\uFF1F" : "\u786E\u5B9A\u6279\u91CF\u52A0\u5165\u56DE\u6536\u7AD9\u5417\uFF1F").then(function () {
        if (type == 5) {
          _this6.onBatchDelete();
        } else {
          _this6.onBatchRecycle();
        }
      });
    },
    //批量删除
    onBatchDelete: function onBatchDelete() {
      var _this7 = this;
      productBatchDeleteApi({
        idList: this.checkedIds
      }).then(function () {
        _this7.$message.success('批量删除成功');
        _this7.tableFrom.page = _this7.tableFrom.page - 1;
        _this7.delSuccess();
      });
    },
    //批量加入回收站
    onBatchRecycle: function onBatchRecycle() {
      var _this8 = this;
      productBatchRecycleApi({
        idList: this.checkedIds
      }).then(function () {
        _this8.$message.success('批量加入回收站成功');
        _this8.tableFrom.page = _this8.tableFrom.page - 1;
        _this8.delSuccess();
      });
    },
    // 删除成功
    delSuccess: function delSuccess() {
      handleDeleteTable(this.tableData.data.length, this.tableFrom);
      this.getList();
      this.goodHeade();
    },
    //添加回馈券
    handleAddCoupon: function handleAddCoupon(row) {
      this.productInfo = row;
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个商品');
      var _this = this;
      this.$modalCoupon('wu', _this.keyNum += 1, [], function (row) {
        row.map(function (item) {
          _this.couponIds.push(item.id);
        });
        _this.onSetCoupons(_this.couponIds);
      }, '');
    },
    //设置优惠券提交
    onSetCoupons: function onSetCoupons(couponIds) {
      var _this9 = this;
      if (this.productInfo) {
        productAddCouponsApi({
          id: this.productInfo.id,
          couponIds: couponIds
        }).then(function () {
          _this9.$message.success('添加回馈券成功');
        });
      } else {
        productBatchAddCouponsApi({
          idList: this.checkedIds,
          couponIds: couponIds
        }).then(function () {
          _this9.$message.success('批量添加回馈券成功');
        });
      }
    },
    // 设置运费
    handleSetFreight: function () {
      var _handleSetFreight = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.productInfo = row;
              if (!(!row && this.checkedIds.length === 0)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, this.$message.warning('请至少选择一个商品'));
            case 1:
              this.dialogVisible = true;
              if (row) this.formValidate.tempId = row.tempId;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleSetFreight(_x) {
        return _handleSetFreight.apply(this, arguments);
      }
      return handleSetFreight;
    }(),
    //设置运费提交
    handleSubmit: function handleSubmit(name) {
      var _this0 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this0.loadingBtn = true;
          if (_this0.productInfo) {
            productSetFreightApi({
              id: _this0.productInfo.id,
              templateId: _this0.formValidate.tempId
            }).then(function () {
              _this0.loadingBtn = false;
              _this0.$message.success('设置运费模板成功');
              _this0.dialogVisible = false;
            }).catch(function () {
              _this0.loadingBtn = false;
            });
          } else {
            productBatchFreightApi({
              idList: _this0.checkedIds,
              templateId: _this0.formValidate.tempId
            }).then(function () {
              _this0.loadingBtn = false;
              _this0.$message.success('批量设置运费模板成功');
              _this0.dialogVisible = false;
            }).catch(function () {
              _this0.loadingBtn = false;
            });
          }
        }
      });
    },
    //取消运费
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.formValidate.tempId = '';
    },
    //设置佣金
    handleSetCommission: function handleSetCommission(row) {
      this.productInfo = row;
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个商品');
      this.resetCommissionForm();
      if (row && row.commissionType === 2) {
        this.commisionForm.commissionType = 2;
      }
      this.dialogCommision = true;
    },
    //设置佣金提交
    submitCommisionForm: function submitCommisionForm(name) {
      var _this1 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          var payload = _this1.commisionForm.commissionType === 2 ? _objectSpread(_objectSpread({}, _this1.commisionForm), {}, {
            brokerage: 0,
            brokerageTwo: 0,
            firstAmount: Number(_this1.commisionForm.firstAmount || 0),
            secondAmount: Number(_this1.commisionForm.secondAmount || 0)
          }) : _objectSpread(_objectSpread({}, _this1.commisionForm), {}, {
            brokerage: Number(_this1.commisionForm.brokerage || 0),
            brokerageTwo: Number(_this1.commisionForm.brokerageTwo || 0),
            firstAmount: 0,
            secondAmount: 0
          });
          if (_this1.productInfo) {
            payload.id = _this1.productInfo.id;
            productBrokerageApi(payload).then(function () {
              _this1.$message.success('设置佣金成功');
              _this1.handleCloseCommission();
            });
          } else {
            payload.idList = _this1.checkedIds;
            productBatchBrokerageApi(payload).then(function () {
              _this1.$message.success('批量设置佣金成功');
              _this1.handleCloseCommission();
            });
          }
        } else {
          return;
        }
      });
    },
    //添加商品
    handleAdd: function handleAdd(type) {
      this.addType = type;
      this.$refs.productTpye.proTypedialogVisible = true;
    },
    //批量下架
    batchDelisting: function batchDelisting(type) {
      var _this10 = this;
      if (this.checkedIds.length === 0) return this.$message.warning('请至少选择一个商品');
      if (type === 'down') {
        this.$modalSure('确定要将选中商品批量下架吗?').then(function () {
          productBatchDownApi({
            idList: _this10.checkedIds
          }).then(function () {
            _this10.$message.success('批量下架成功');
            _this10.getList(1);
            _this10.goodHeade();
          });
        });
      } else {
        this.$modalSure('确定要将选中商品批量上架吗?').then(function () {
          productBatchUpApi({
            idList: _this10.checkedIds
          }).then(function () {
            _this10.$message.success('批量上架成功');
            _this10.getList(1);
            _this10.goodHeade();
          });
        });
      }
    },
    // 设置选中的方法
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelectionAll = val;
      var data = [];
      this.multipleSelectionAll.map(function (item) {
        data.push(item.id);
      });
      this.checkedIds = data;
    },
    selectAll: function selectAll(data) {
      var id = data.map(function (i, index) {
        return i.id;
      });
      this.checkedIds = Array.from(new Set([].concat(_toConsumableArray(this.checkedIds), _toConsumableArray(id))));
    },
    selectOne: function selectOne(data, row) {
      var id = data.map(function (i, index) {
        return i.id;
      });
      var index = this.checkedIds.findIndex(function (e) {
        return e == row.id;
      });
      this.checkedIds.splice(index, 1);
      this.checkedIds = Array.from(new Set([].concat(_toConsumableArray(this.checkedIds), _toConsumableArray(id))));
    },
    //编辑商品
    onEdit: function onEdit(row) {
      var _this11 = this;
      //id:商品id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集商品(1是，2不是)
      if (this.tableFrom.type === '1') {
        this.$modalSure('下架该商品吗？出售商品需下架之后可编辑。').then(function () {
          offShellApi(row.id).then(function () {
            _this11.$router.push({
              path: "/product/list/creatProduct/".concat(row.id, "/2/2/").concat(row.type)
            });
          });
        });
      } else {
        this.$router.push({
          path: "/product/list/creatProduct/".concat(row.id, "/2/2/").concat(row.type)
        });
      }
    },
    //编辑库存成功回调
    subSuccess: function subSuccess() {
      this.drawer = false;
      this.handleSeachList();
    },
    handleEdit: function handleEdit(row, stockEdit) {
      this.productId = row.id;
      this.productType = row.type;
      this.isSub = row.isSub;
      this.drawer = true;
      this.stockEdit = stockEdit;
    },
    handleCloseEdit: function handleCloseEdit() {
      this.drawer = false;
    },
    handleAudit: function handleAudit(id) {
      var _this12 = this;
      // this.$modalSure('提审商品吗').then(() => {
      //   productAuditApi(id).then((res) => {
      //     this.goodHeade();
      //     this.getList();
      //   });
      // });
      this.$confirm('提审之后是否自动上架？', '提示', {
        confirmButtonText: '上架',
        cancelButtonText: '不用了',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      }).then(function () {
        _this12.productAudit({
          id: id,
          isAutoUp: true
        });
      }).catch(function () {
        _this12.productAudit({
          id: id,
          isAutoUp: false
        });
      });
    },
    //恢复商品
    handleRestore: function handleRestore(row) {
      var _this13 = this;
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个商品');
      this.$modalSure(!row ? '确定批量恢复商品吗？' : '确定恢复商品吗？').then(function () {
        if (row) {
          restoreApi(row.id).then(function (res) {
            _this13.$message.success('恢复商品成功');
            _this13.goodHeade();
            _this13.getList(1);
          });
        } else {
          productBatchRestoreApi({
            idList: _this13.checkedIds
          }).then(function (res) {
            _this13.$message.success('批量恢复商品成功');
            _this13.goodHeade();
            _this13.getList(1);
          });
        }
      });
    },
    handleSeachList: function handleSeachList() {
      this.getList(1);
      this.goodHeade();
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.cateId = '';
      this.tableFrom.keywords = '';
      this.tableFrom.categoryId = '';
      this.tableFrom.isPaidMember = null;
      this.tableFrom.productType = null;
      this.keywords = '';
      this.handleSeachList();
    },
    // 导出
    exports: function exports() {
      productExcelApi({
        cateId: this.tableFrom.cateId,
        keywords: this.tableFrom.keywords,
        type: this.tableFrom.type
      }).then(function (res) {
        window.location.href = res.fileName;
      });
    },
    // 获取商品表单头数量
    goodHeade: function goodHeade() {
      var _this14 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.type;
      productHeadersApi(data).then(function (res) {
        res.map(function (item) {
          item.name = objTitle[Number(item.type) - 1];
        });
        _this14.headeNum = res;
      }).catch(function (res) {
        _this14.$message.error(res.message);
      });
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    // 列表
    getList: function getList(num) {
      var _this15 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      productLstApi(this.tableFrom).then(function (res) {
        _this15.tableData.data = res.list;
        _this15.tableData.total = res.total;
        _this15.listLoading = false;
      }).catch(function (res) {
        _this15.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //详情
    handleInfo: function handleInfo(id, type) {
      this.$router.push({
        path: "/product/list/creatProduct/".concat(id, "/2/2/").concat(type)
      });
    },
    // 删除
    handleDelete: function handleDelete(id, type) {
      var _this16 = this;
      this.$modalSure(type == 5 ? "\u5220\u9664 id \u4E3A ".concat(id, " \u7684\u5546\u54C1") : "id\u4E3A".concat(id, "\u7684\u5546\u54C1\u52A0\u5165\u56DE\u6536\u7AD9\u5417")).then(function () {
        var deleteFlag = type == 5 ? 'delete' : 'recycle';
        productDeleteApi({
          id: id,
          type: deleteFlag
        }).then(function () {
          _this16.$message.success('删除成功');
          _this16.delSuccess();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this17 = this;
      row.isShow ? putOnShellApi(row.id).then(function () {
        _this17.$message.success('上架成功');
        _this17.getList(1);
        _this17.goodHeade();
      }).catch(function () {
        row.isShow = !row.isShow;
      }) : offShellApi(row.id).then(function () {
        _this17.$message.success('下架成功');
        _this17.getList(1);
        _this17.goodHeade();
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('goods_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    }
  }
};